export default "__VITE_ASSET__Cw$Wtmhl__"